module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-4.7e6089a9.svg";